import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../../../components/ErpTemplate';
import { FaSave } from 'react-icons/fa';
import api from '../../../../services/api';
import { useHistory } from 'react-router-dom';
import ReactSelect from '../../../../components/ReactSelect';
import { extract } from '../../../../util/util';
import { toast } from 'react-toastify';
import { FinField, FinInput } from '../../../../components/FinField';
import '../../../../css/financeiro-parcela-pagar.css';


export default function CadastroEventoChecklistAtividade({ match }) {
    const id = match.params.id;
    const empresa = localStorage.getItem("empresa");
    const token = localStorage.getItem('token');
    const [dados, setDados] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const history = useHistory();

    const buscar = () => {
        if (id) {
            api({
                method: "get",
                action: '/eventoChecklistAtividade/' + id,
                token: token,
            }).then(response => {
                var dadosRecebidos = extract({
                    jsonLaravel: response.data.data,
                    chaves: [
                        'superior',
                        'requisito'
                    ]
                });
                setDados(dadosRecebidos);
            }).catch(err => {
                //console.log(err)
            });
        }
    };

    const salvar = () => {
        if (isSubmitting) {
            return;
        }

        setIsSubmitting(true);
        if (id) {
            api({
                method: 'put',
                action: '/eventoChecklistAtividade/' + id,
                token: token,
                data: dados
            })
                .then(function (response) {
                    toast.success("Dados salvos com sucesso!");
                    history.push("/eventoChecklistAtividade");
                })
                .catch(function (error) {
                    toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
                })
                .finally(() => {
                    setIsSubmitting(false);
                });
        } else {
            api({
                method: 'post',
                action: '/eventoChecklistAtividade',
                token: token,
                data: { ...dados, ...{ empresa: empresa } }
            })
                .then(function (response) {
                    toast.success("Dados salvos com sucesso!");
                    history.push("/eventoChecklistAtividade");
                })
                .catch(function (error) {
                    toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
                })
                .finally(() => {
                    setIsSubmitting(false);
                });
        }
    };

    useEffect(() => {
        document.querySelector("#nome").focus();
        buscar();
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div><h1 className="fin-pp__title">Atividade</h1></div>
                </div>
                <form onSubmit={e => { salvar(); e.preventDefault(); }}>
                    <div className="fin-pp__card" style={{ padding: 16, marginBottom: 16 }}>
                        <div className="fin-pp__filters">
                            <FinField label="Código">
                                <FinInput
                                    id="codigo"
                                    type="text"
                                    placeholder="automático"
                                    readOnly={true}
                                    value={dados.codigo || ''}
                                    onChange={e => setDados({ ...dados, ...{ "codigo": e.target.value } })}
                                />
                            </FinField>
                            <FinField label="Ordem">
                                <FinInput
                                    id="ordem"
                                    type="text"
                                    placeholder="automático"
                                    value={dados.ordem || ''}
                                    onChange={e => setDados({ ...dados, ...{ "ordem": e.target.value } })}
                                />
                            </FinField>
                            <FinField label="Superior">
                                <ReactSelect
                                    value={{ value: dados.superior, label: dados.nomeSuperior }}
                                    onChange={e => setDados({ ...dados, ...{ "superior": e.value, "nomeSuperior": e.label } })}
                                    loadOptions={(input) => {
                                        return api({
                                            method: 'get',
                                            action: '/eventoChecklistAtividade',
                                            token: token,
                                            params: {
                                                nome: input,
                                            }
                                        })
                                            .then(response => {
                                                let options = response.data.data.map(registro => ({ value: registro.id, label: registro.codigo + " - " + registro.nome }));
                                                return options;
                                            })
                                            .catch(function (error) {
                                                //console.log(error);
                                            });
                                    }}
                                />
                            </FinField>
                            <FinField label="Requisito">
                                <ReactSelect
                                    value={{ value: dados.requisito, label: dados.nomeRequisito }}
                                    onChange={e => setDados({ ...dados, ...{ "requisito": e.value, "nomeRequisito": e.label } })}
                                    loadOptions={(input) => {
                                        return api({
                                            method: 'get',
                                            action: '/eventoChecklistAtividade',
                                            token: token,
                                            params: {
                                                nome: input,
                                            }
                                        })
                                            .then(response => {
                                                let options = response.data.data.map(registro => ({ value: registro.id, label: registro.codigo + " - " + registro.nome }));
                                                return options;
                                            })
                                            .catch(function (error) {
                                                //console.log(error);
                                            });
                                    }}
                                />
                            </FinField>
                            <FinField label="Nome">
                                <FinInput
                                    id="nome"
                                    type="text"
                                    placeholder="Nome"
                                    value={dados.nome || ''}
                                    onChange={e => setDados({ ...dados, ...{ "nome": e.target.value } })}
                                />
                            </FinField>
                            <FinField label="Prazo (dias)">
                                <FinInput
                                    id="prazo"
                                    type="text"
                                    placeholder="Prazo"
                                    value={dados.prazo || ''}
                                    onChange={e => setDados({ ...dados, ...{ "prazo": e.target.value } })}
                                />
                            </FinField>
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 24 }}>
                        <button type="submit" className="fin-pp__btn fin-pp__btn--primary" disabled={isSubmitting}>
                            {isSubmitting ? <><span className="spinner-border spinner-border-sm me-2" />Salvando...</> : <><FaSave size={16} /> Salvar</>}
                        </button>
                    </div>
                </form>
            </div>
        </ErpTemplate>
    );
}
